import { FC, ReactNode } from 'react';
import { Box } from '@mui/material';
import { DrawerComponent } from '@components';

interface SidepanelLayoutProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

/**
 * Wraps DrawerComponent with a standard right-anchored drawer shell and
 * a flex-column container — shared by all AppAccess sidepanel variants.
 */
const SidepanelLayout: FC<SidepanelLayoutProps> = ({ open, onClose, children }) => (
  <DrawerComponent
    open={open}
    anchor="right"
    close={onClose}
    height="98vh"
    zIndex={1200}
    backgroundColor="#FFFFFF"
  >
    <Box
      sx={{
        width: 'min(95vw, 600px)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: '#FFFFFF',
        padding: '1.5rem',
      }}
    >
      {children}
    </Box>
  </DrawerComponent>
);

export default SidepanelLayout;
